import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">i88 · Your Gaming Destination</p>
        <h1>Experience the Thrill of Gaming</h1>
        <p className="lede">
          Dive into an exciting world of casino-style games, poker, and sports betting tailored for UK residents. Join us and elevate your gaming experience today!
        </p>
        <div className="cta-row">
          <a href="/games" target="_self">
            Explore Our Games
          </a>
          <a href="/signup" target="_self" className="secondary">
            Join Now
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Play Anytime, Anywhere</h2>
          <p>
            Enjoy your favorite games on the go with our user-friendly platform designed for seamless gaming experiences.
          </p>
        </article>
        <article>
          <h2>Join the Action</h2>
          <p>
            Participate in thrilling poker tournaments and sports betting events. Test your skills and win big!
          </p>
        </article>
        <article>
          <h2>Safe and Secure</h2>
          <p>
            Your safety is our priority. Enjoy peace of mind with our secure payment options and responsible gaming practices.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;